import { QueryOptions } from 'react-query';
import { getOrgsWithFarmAccess } from './farm-orgs.api';
import { FarmOrgAccessResponse } from './farm-orgs.schema';

export const FARM_ORGS_QUERY_KEY_PREFIX = 'farm-orgs';

export const getFarmOrgsQuery = (
  solarFarmId: number,
  solarFarmOrgId: number,
): QueryOptions<FarmOrgAccessResponse> => ({
  queryKey: [FARM_ORGS_QUERY_KEY_PREFIX, { solarFarmOrgId, solarFarmId }],
  queryFn: () => getOrgsWithFarmAccess(solarFarmId, solarFarmOrgId),
});
